/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { TrfToVanProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const trfToVanProcessFetchTrfToVanProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const trfToVanProcessFetchTrfToVanProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [TrfToVanProcessTypes.TRF_TO_VAN_PROCESS_FETCH_TRF_TO_VAN_PROCESS_LOADING]: trfToVanProcessFetchTrfToVanProcessLoading,
  [TrfToVanProcessTypes.TRF_TO_VAN_PROCESS_FETCH_TRF_TO_VAN_PROCESS_SUCCESS]: trfToVanProcessFetchTrfToVanProcessSuccess
});
